import { SETTING_TYPE_HEADER_ANALYSIS_THREAT_SCORING } from '../../constants/contants';

export const isHeaderAnalysisEnabled = (setting: Record<string, any> | undefined | null): boolean =>
  setting?.[SETTING_TYPE_HEADER_ANALYSIS_THREAT_SCORING] !== false;
